import { memo } from 'react';
import { VStack } from '@cbhq/cds-web/layout';
import { Spinner } from '@cbhq/cds-web/loaders';

export const LoadingPage = memo(function LoadingPage() {
  return (
    <VStack justifyContent="center" alignItems="center" flexGrow={1}>
      <Spinner color="primary" size={4} />
    </VStack>
  );
});
